import React from 'react';
import { supported as lsSupported } from 'bv-local-storage';
import { hasSportsbook } from 'global-config';
import withLazyLoad from 'bv-lazy-load';

import { CenterContent, LocalStorageWarning } from './components';

const RightSidebar = hasSportsbook ? withLazyLoad()('rightSidebar') : () => null;
const SmartAppBanner = withLazyLoad()('layoutApps.smartAppBanner');
const FloatingNavigation = withLazyLoad()('layoutApps.floatingNavigation');
const LeftComponents = withLazyLoad()('layoutApps.leftComponents');

export default () => (
  lsSupported() ? (
    <>
      <SmartAppBanner />
      <LeftComponents />
      <RightSidebar />
      <CenterContent />
      <FloatingNavigation />
    </>
  ) : <LocalStorageWarning />
);
